import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONFIG } from '../../constants/constants';
import { IHardware } from '../../model/hardware';
import { ESTADO_VALID_CPU } from '../../model/estadoValidCPU';
import { ConfigurationControlService } from '../configuration/configurationControl.service';
import { TokenControlService } from '../state/tokenControl.service';
import { Router } from '@angular/router';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import * as fs from 'file-saver';
import { DateServerService } from '../dateServerService/date-server.service';
import { NavigateDemoGuard } from '../../guards/navigateDemo.guard';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class ValidacionPcService {
  public cpu: string;
  public cpuSpeed: number;
  public MAC: string;
  public ram: number;
  public ramFree: number;
  public so: string ;
  public arc: string;
  public kiosko : boolean = false;
  public screenWidth: number;
  public screenHeigth: number;
  public speedTest : number;
  public diskFree : number;
  public countSpeedTest : number;
  public teclado:boolean;
  public mouse: boolean;
  
  private urlImagenTest : string = "/src/assets/icons/test.jpeg" //"/src/app/resources/img/icono-usuario-big.png";
  private sizeImageTest: number = 1666891;
  private startTimeImageTest : number = 0;
  private endTimeImageTest : number = 0;
  private downloadImageTest = new Image();
  private itemsTest: number[] = [];
  public messageSystemOp: string = "";
  public versionSystemOp: string = "";
  public finishAllSave: boolean;// indica si fanlizo todas la validacion y guardado
  public finishSave: boolean;// indica si fanlizo todas la validacion y guardado
  private SLEEP = 4000;
  private inProcess:boolean = false;

  constructor(
    private http: HttpClient,
    private router:Router,
    private _tokenController: TokenControlService,
    public _configurationControlService: ConfigurationControlService,
    private _dateServerService: DateServerService,
    private _navigateDemoGuard: NavigateDemoGuard) { 
     
      this.kiosko = localStorage.getItem("KIOSKO") == "true";
   }

   public getCPU(){
    this.cpu = localStorage.getItem("cpu") != null ? localStorage.getItem("cpu") : "" ;
    return this.cpu;
   }
   public getTeclado(){
    return localStorage.getItem("teclado") == "true"
   }

   public getMouse(){
    return localStorage.getItem("mouse") == "true"
   }
   
   public getVelocidadInternet(){
     return localStorage.getItem("speedTest")
   }

   public getVersionSystemOp(){
    return localStorage.getItem("version_so")
  }
  
   public getRAM(){
    this.ram = parseInt(localStorage.getItem("ram"));
    if(isNaN(this.ram)){
      this.ram = 0;
    }
    return this.ram;
   }

   public getRAMFree(){
    this.ramFree = parseInt(localStorage.getItem("ram_free"));
    if(isNaN(this.ramFree)){
    this.ramFree = 0;
    }
    return this.ramFree;
   }
   
   public getCpuSpeed(){
    this.cpuSpeed = parseFloat(localStorage.getItem("cpu_speed")) ;
    if(isNaN(this.cpuSpeed)){
    this.cpuSpeed = 0;
    }

    return  this.cpuSpeed;
   }

   public getDiskFree(){
    this.diskFree = parseFloat(localStorage.getItem("disk_free")) ;
    if(isNaN(this.diskFree)){
    this.diskFree = 0;
    }
    return this.diskFree
   }

   public getSO(){
    this.so = localStorage.getItem("so") != null ? localStorage.getItem("so") : "";
     return this.so
   }

   public getArc(){
    this.arc = localStorage.getItem("arc") != null ? localStorage.getItem("arc") : "" ;
    return this.arc
   }
   
   public getScreenHeigth(){
    this.screenHeigth = screen.height;
    return this.screenHeigth 
   }

   public getScreenWidth(){
    this.screenWidth = screen.width;
    return this.screenWidth
   }

  public initTestAll(validSpeed: boolean){
    if(this.inProcess == false){
      this.inProcess= true;
      this.countSpeedTest = 0;
      this.finishAllSave = false;
      this.finishSave = false;
      this.teclado = false;
      this.mouse = false;
      this.itemsTest = [];
      this.getCPU()
      this.getRAM()
      this.getRAMFree()
      this.getCpuSpeed()
      this.MAC = localStorage.getItem("mac") != null ? localStorage.getItem("mac") : "" ;
      this.getDiskFree()
      this.getSO()
      this.getScreenWidth();
      this.getScreenHeigth();
      this.itemsTest = [];
      if(this.kiosko &&  validSpeed){
      this.starTestSpeed();
      } 
    }
  }

  public showValid(){
   if( this.kiosko && CONFIG.ONLINE){
       this.initTestAll(true);
      $('#modal-valid-pc').modal({backdrop: 'static', keyboard: false});
      $("#btValidModal").attr("disabled", true)
      setTimeout( () => { $("#btValidModal").attr("disabled", false)}, 1000)
    }
  }

  public finishAllProcess(){

    return this.finishAllSave || 
    (this.finishSave && this.teclado && this.mouse);
  
  }

  public async hideValid(){
    this.saveHardwarePC().then(()=> { 
        this.inProcess = false;
        $("#btValidModal").attr("disabled", true)
        $('#modal-valid-pc').modal('hide');
        if(this.isBlocking()){
        this.generarExcelValid( () => {
          setTimeout( () => {
            window.close();
            this.router.navigate(["/login"]);
          }, 500);      
        })   
      }
    }); 
  }

  public validSystemOperative(){
    const systemOpe = navigator.userAgent.toLocaleLowerCase();
    let validacion = true;
    if(/mac os x/.test(systemOpe)){
      validacion = this.validMacOSX(systemOpe);
    }else if(/windows nt/.test(systemOpe)){
      validacion = this.validWindows(systemOpe);
    }else if(/ubuntu/.test(systemOpe)){
      validacion = this.validLinux(systemOpe);
    } 

    if(validacion)
      return ESTADO_VALID_CPU.COMPLETO;
    
    return ESTADO_VALID_CPU.BAJO;
  }

  private validLinux(systemOpe: string){
    this.messageSystemOp = "Se requiere ubuntu 18 o superior";
    this.versionSystemOp = "ubuntu";
    try{
      const partVersion = systemOpe.match(/ubuntu/)[0];
      return partVersion != null;
    }catch(e){
      return false;
    }
  }


  private validWindows(systemOpe: string){
    this.versionSystemOp ="windows"
    try{
      this.messageSystemOp = "Se requiere Windows 7 o superior";
      const partVersion = systemOpe.match(/windows nt [0-9]{1,2}.[0-9]{1,2}/)[0];
      this.versionSystemOp = this.getWindowsOS(partVersion);
      const listPartVersion = partVersion.split(" ")[2].split(".");
      const vn1 = parseInt(listPartVersion[0])

      return vn1 >= 6;
    }catch(e){
      return true;
    }
  }

    getWindowsOS( windowsnt:string){
    if(windowsnt.indexOf("windows nt 10.")!=-1){
      return 'Windows 10';
    }else if(windowsnt.indexOf("windows nt 6.3")!=-1){
      return "Windows 8.1";
    }else if(windowsnt.indexOf("windows nt 6.2")!=-1){
      return "Windows 8";
    }else if(windowsnt.indexOf("windows nt 6.1")!=-1){
      return "Windows 7";
    }else if(windowsnt.indexOf("windows nt 6.0")!=-1){
      return "Windows Vista";
    }else if(windowsnt.indexOf("windows nt 5.2")!=-1){
      return "Windows Server 2003; Windows XP x64 Edition";
    }else if(windowsnt.indexOf("windows nt 5.1")!=-1){
      return "Windows XP";
    }else if(windowsnt.indexOf("windows nt 5.01")!=-1){
      return "Windows 2000, Service Pack 1 (SP1)";
    }else if(windowsnt.indexOf("windows nt 5.0")!=-1){
      return "Windows 2000";
    }else if(windowsnt.indexOf("windows nt 4.0")!=-1){
      return "Windows NT 4.0";
    }else if(windowsnt.indexOf("windows 98")!=-1){
      return "Windows Millennium Edition (Windows Me)";
    }else if(windowsnt.indexOf("windows 98")!=-1){
      return "Windows 98";
    }else if(windowsnt.indexOf("windows 95")!=-1){
      return "Windows 95";
    }else if(windowsnt.indexOf("windows ce")!=-1){
      return "Windows CE";
    }else{
      return windowsnt;
    }
  }

  private validMacOSX(systemOpe: string){
    this.versionSystemOp = "mac os";
    try{
      this.messageSystemOp = "Se requiere Mac OS X 10.14 o superior";
      const partVersion = systemOpe.match(/mac os x [0-9]{1,2}_[0-9]{1,2}/)[0];
      this.versionSystemOp = partVersion;
      const listPartVersion = partVersion.split(" ")[3].split("_");
      const vn1 = listPartVersion.length > 0 ? parseInt(listPartVersion[0]) : 0;
      const vn2 = listPartVersion.length > 1 ? parseInt(listPartVersion[1]) : 0;
      
      return (vn1 == 10 && vn2 >= 14) || vn1 > 10;

    }catch(e){

      return true;
    }
   
  }

  private starTestSpeed(iteracion: number = 0){
    if(iteracion == 0){
      this.itemsTest = [];
    }
    if(iteracion < 3){
      this.downloadImageTest.onload = () => { 
        this.finishTestSpeed(); 
        this.starTestSpeed(iteracion + 1)}
      this.downloadImageTest.onerror = () => {  
        this.countSpeedTest++; 
        this.speedTest = 0; 
        this.starTestSpeed(iteracion + 1); }
      this.startTimeImageTest = (new Date()).getTime();
      const cacheBuster = "?rand=" + this.startTimeImageTest;
      this.downloadImageTest.src = this.urlImagenTest + cacheBuster;
    }else {
        this.finishSave = true;
          setTimeout(() => { this.finishAllSave = true;}, this.SLEEP)
      }
  }

  public saveHardwarePC(){
    const hardware : IHardware = {
      idUsuario: this._tokenController.token.credentialId,
      ip : this._configurationControlService.publicIp,
      ram: this.ram,
      sistemaOperativo: this.versionSystemOp,
      velocidaInternet: this.speedTest,
      pantallaAlto: this.screenHeigth,
      pantallaAncho: this.screenWidth,
      velocidadProcesador: this.cpuSpeed,
      cumple: !this.isBlocking(),
      teclado : this.teclado,
      mouse : this.mouse,
      fechaCreacion : this._dateServerService.getDateServer() 
    };

    localStorage.setItem("teclado", this.teclado+"")
    localStorage.setItem("mouse", this.mouse+"")
    localStorage.setItem("speedTest", this.speedTest+"")
    localStorage.setItem("version_so", this.versionSystemOp+"")

    return this.http.post(CONFIG.REST_END_POINT + 'save/hardware/', hardware)
    .toPromise();

  }

  private finishTestSpeed () {
    this.endTimeImageTest = (new Date()).getTime();
    var duration = (this.endTimeImageTest - this.startTimeImageTest) / 1000;
    var bitsLoaded = this.sizeImageTest * 8;
    const speedBps = (bitsLoaded / duration);
    const speedKbps = (speedBps / 1024);
    const speedMbps = (speedKbps / 1024);
    this.itemsTest.push(speedMbps)
    const sumItems = this.itemsTest.reduce((previous, current) => current += previous);
    this.speedTest = sumItems / this.itemsTest.length;
    this.countSpeedTest++;
  }

  public getSpeedTestUnit(){
    if(this.speedTest > 0 ){
      let partIntSpeed = 0;
      let countItem = 0;
      const unitsSepped = ["Mbps","kbps","Bps"];
      let convertSpeedTest = this.speedTest;
      do{
        countItem++;
        partIntSpeed = parseInt(convertSpeedTest.toFixed(0));
        if(countItem > 2)
          convertSpeedTest = convertSpeedTest * 1024;
      }
      while(partIntSpeed <= 0 && countItem < 3)
    
      return `${convertSpeedTest.toFixed(3)} ${unitsSepped[countItem -1 ]}` 
    }else {

      return "0Mbps";
    }
  }

  public validCPU(){
    let validacion = ESTADO_VALID_CPU.BAJO;
    if(this.cpuSpeed < 1){
       validacion = ESTADO_VALID_CPU.BAJO;
    }else if(this.cpuSpeed < 1.6){
       validacion = ESTADO_VALID_CPU.ACEPTABLE;
    }else {
      validacion = ESTADO_VALID_CPU.COMPLETO;
    }

    return validacion;
  }

  public validDiskFree(){
    let validacion = ESTADO_VALID_CPU.BAJO;
    if(this.diskFree < 400){
       validacion = ESTADO_VALID_CPU.BAJO;
    }else if(this.diskFree < 4000){
       validacion = ESTADO_VALID_CPU.ACEPTABLE;
    }else {
      validacion = ESTADO_VALID_CPU.COMPLETO;
    }

    return validacion;
  }

  public validRAM(){
    let validacion = ESTADO_VALID_CPU.BAJO;
    if(this.ram < 1){
       validacion = ESTADO_VALID_CPU.BAJO;
    }else if(this.ram < 2){
      validacion = ESTADO_VALID_CPU.ACEPTABLE;
    }else {
      validacion = ESTADO_VALID_CPU.COMPLETO;
    }
    return validacion;
  }

  public validScreenWidth(){
    let validacion = ESTADO_VALID_CPU.BAJO;
    if(this.screenWidth < 1280){
      validacion = ESTADO_VALID_CPU.BAJO;
    }else if(this.screenWidth < 1360){
      validacion = ESTADO_VALID_CPU.ACEPTABLE;
    }else {
     validacion = ESTADO_VALID_CPU.COMPLETO;
    }

   return validacion;
  }

  public validHeigth(){
    let validacion = ESTADO_VALID_CPU.BAJO;
    if(this.screenHeigth < 768){
      validacion = ESTADO_VALID_CPU.BAJO;
    }else {
     validacion = ESTADO_VALID_CPU.COMPLETO;
    }

   return validacion;
  }

   public isBlocking(){
    return [ this.validCPU(), this.validHeigth(), this.validScreenWidth(),
    this.validRAM()].indexOf(ESTADO_VALID_CPU.BAJO) != -1
  }

  public validRamFree(){
    let validacion = ESTADO_VALID_CPU.BAJO;
    if(this.ramFree < 0.5){
      validacion = ESTADO_VALID_CPU.BAJO;
    }else if(this.ramFree < 1){
      validacion = ESTADO_VALID_CPU.ACEPTABLE;
    }else {
     validacion = ESTADO_VALID_CPU.COMPLETO;
    }

   return validacion;
  }

  public async generarExcelValid(callback: Function = null){
    try {
      if(this._navigateDemoGuard.activateDemo && this.kiosko){
        const title = "validacion - equipo"
        const fecha = this._dateServerService.getDateServer()
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Caracteristica equipo');
        worksheet.mergeCells('A1', 'L1');
        let titleRow = worksheet.getCell('A1');
        titleRow.value = "VALIDACIÓN REQUERIMIENTOS DE SOFTWARE Y HARDWARE- PLEXI"
        const headers = ["TIPO EXAMEN","TIPO DOCUMENTO",
        "NUMERO DOCUMENTO",	"VELOCIDAD INTERNET","SISTEMA OPERATIVO"	,"PROCESADOR",	"MEMORIA RAM",
          "PANTALLA ANCHO",	"RESOLUCIÓN PANTALLA ALTO",	
          "MOUSE","TECLADO","FECHA DE GENERACIÓN REPORTE"];
        worksheet.addRow(headers);
        worksheet.addRow([
          this._tokenController.userDemo.tipoExamen?  this._tokenController.userDemo.tipoExamen.nombre : "",
          this._tokenController.userDemo.tipDocumento,
          this._tokenController.userDemo.numeroDocumento,
          this.getVelocidadInternet()+" MB",
          this.getVersionSystemOp() + ":" + navigator.userAgent.toLocaleLowerCase(),
          this.getCpuSpeed() +" GHz",
          this.getRAM() + "MB free:"+this.getRAMFree()+"MB",
          this.getScreenWidth()+" px",
          this.getScreenHeigth()+" px",
          this.getMouse() ? "SI":"NO",
          this.getTeclado() ? "SI":"NO",
          fecha.toLocaleString()
        ]); 
        workbook.xlsx.writeBuffer().then(async (data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          var downloadLink = document.createElement("a");
          downloadLink.download = "validacion";
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.click();
           if(callback){
              callback()
            }
        })
      }
      
    } catch (error) {
      if(callback){
        callback()
      }
      console.error(error);
    }
    
  }
}
